document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var main = document.getElementById('main');
  if (!main) return;

  var sections = main.querySelectorAll('.shopify-section');
  var targets = [];

  var skip = {STYLE: 1, LINK: 1, SCRIPT: 1, NOSCRIPT: 1, META: 1};

  sections.forEach(function (wrapper) {
    var child = wrapper.firstElementChild;
    while (child && skip[child.tagName]) {
      child = child.nextElementSibling;
    }
    if (!child || child.hasAttribute('data-no-reveal')) return;

    var rect = wrapper.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) return;

    child.classList.add('section-reveal');
    targets.push(child);
  });

  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('section-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
});
